module.exports = __webpack_public_path__ + "hinted-Montserrat-ThinItalic.006cf3cf26164af137c3.eot";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/hinted-Montserrat-ThinItalic.eot
// module id = ../../../../../src/assets/custom-styles/fonts/hinted-Montserrat-ThinItalic.eot
// module chunks = 1